import { render, staticRenderFns } from "./allocationStorehouseManageList.vue?vue&type=template&id=994d0e78&scoped=true"
import script from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseManageList.vue?vue&type=style&index=0&id=994d0e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d0e78",
  null
  
)

export default component.exports